import React from 'react';
import { Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';


export const BottomInstrucciones = () => {
  const handleClick = () => {
    window.open("https://laboratoriocamusso-com.gitbook.io/laboratoriocamusso.com", "_blank")
  };

  return (
    <div className="bottom-component" onClick={handleClick}>
      <Button type="primary" icon={<ExclamationCircleOutlined />} className="round-button">
        AYUDA
      </Button>
    </div>
  );
};
